export type CategoryGroup = {
  key: string;
  label: string;
  options: string[];
};

export const genreOptions: string[] = ['剧情', '爱情', '悬疑', '历史', '喜剧', '动作'];

export const yearOptions: string[] = [
  '2024',
  '2023',
  '2022',
  '2021',
  '2020',
  '2019',
  '2018',
  '2017',
  '2016',
];

export const countryOptions: string[] = ['日本'];

export type QuickCategory = {
  name: string;
  description: string;
  query: string;
  icon: string;
};

export const quickCategories: QuickCategory[] = [
  {
    name: '剧情片',
    description: '细腻刻画人物命运的深度作品',
    query: '剧情',
    icon: 'ri-film-line',
  },
  {
    name: '爱情片',
    description: '关于相遇、错过与重逢的故事',
    query: '爱情',
    icon: 'ri-heart-3-line',
  },
  {
    name: '悬疑片',
    description: '层层揭开的谜团与真相',
    query: '悬疑',
    icon: 'ri-search-eye-line',
  },
  {
    name: '历史片',
    description: '重现时代风貌的史诗之作',
    query: '历史',
    icon: 'ri-book-2-line',
  },
  {
    name: '喜剧片',
    description: '轻松治愈的生活小品',
    query: '喜剧',
    icon: 'ri-emotion-happy-line',
  },
  {
    name: '动作片',
    description: '节奏紧凑的强类型作品',
    query: '动作',
    icon: 'ri-flashlight-line',
  },
];